import { cx } from '@flowus/common/cx';
import { Icon } from '@flowus/common/icon-svg/pc-icon';

interface PrivateMoreButtonProps {
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
}

export const PrivateMoreButton = (props: PrivateMoreButtonProps) => {
  const { onClick, className } = props;

  return (
    <div
      className={cx(
        'w-full text-t2 relative mx-2 px-2 flex items-center space-x-2 rounded-md animate-hover-black3 py-1 my-1 cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      <div className="flex items-center space-x-2">
        <Icon name="IcMore" size="middle" className="text-grey3" />
        <div className="flex-1 text-t2-medium text-grey3 animate-hover-black3">查看更多</div>
      </div>
    </div>
  );
};
